import { render } from "./EntityHeadersView.vue?vue&type=template&id=00bc8535&scoped=true"
import script from "./EntityHeadersView.vue?vue&type=script&lang=js"
export * from "./EntityHeadersView.vue?vue&type=script&lang=js"

import "./EntityHeadersView.vue?vue&type=style&index=0&id=00bc8535&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00bc8535"]])

export default __exports__